import * as React from 'react';
import { jsx } from '@emotion/react';
import { ErrorMessage } from '../messages/error-message/error-message.js';
import { WarningMessage } from '../messages/warning-message/warning-message.js';
import Text from '../text/text.js';

var FieldMessage = function FieldMessage(_ref) {
  var error = _ref.error,
      helpText = _ref.helpText,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
      warning = _ref.warning;
  var showError = false;
  var showWarning = false;
  var showHelpText = false;
  if (isVisible && error && typeof error === 'string' && error.length) {
    showError = true;
  } else if (isVisible && warning && typeof warning === 'string' && warning.length) {
    showWarning = true;
  } else if ( React.isValidElement(helpText) || typeof helpText === 'string' && helpText && helpText.length) {
    showHelpText = true;
  }
  return jsx(React.Fragment, null, showError && jsx(ErrorMessage, null, error), showWarning && jsx(WarningMessage, null, warning), showHelpText && jsx(Text.Body, {
    color: "secondary",
    size: "xs"
  }, helpText));
};
FieldMessage.displayName = 'FieldMessage';

export { FieldMessage };
//# sourceMappingURL=field-message.js.map
